import React from 'react';
const CHECKOUT_URL = 'https://checkout.ecompradigital.online/cart/46114651766972:1';
export function BonusSection() {
  const bonuses = [{
    title: 'Mejores plantas para empezar',
    desc: 'Para saber exactamente qué cultivar',
    image: 'https://cdn.magicpatterns.com/uploads/1hi6gDV2GP9eHVt9XWUXwP/BONUS1.jpg'
  }, {
    title: 'Guía plantas + mascotas',
    desc: 'Mantén tu hogar seguro',
    image: 'https://cdn.magicpatterns.com/uploads/rj4nGY2D3ZHvQaeppRTyvd/BONUS2.jpg'
  }, {
    title: 'Sistema imprimible',
    desc: 'Checklist, planner y seguimiento',
    image: 'https://cdn.magicpatterns.com/uploads/1rUL17xnj4fp1exqKSDWXv/BONUS3.jpg'
  }, {
    title: 'Pack de plantillas',
    desc: 'Organiza, planifica y mantené tu huerta de manera simple',
    image: 'https://cdn.magicpatterns.com/uploads/uRhUzfq8Qxig2SXhJ346xs/PACKDEPLANTILLAS.png'
  }];
  return <section className="relative bg-neutral-bg py-10 px-4 sm:px-6 lg:px-8 border-t border-neutral-beige" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <div className="text-center mb-6" data-id="element-3">
          <span className="inline-block bg-earth-accent/10 text-earth-accent font-bold px-4 py-1 rounded-full mb-2 text-xs tracking-widest uppercase" data-id="element-4">
            Regalos Exclusivos
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl font-black text-[#1A1A1A]" data-id="element-5">
            🎁 Bonos incluidos
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-6">
          {bonuses.map((bonus, index) => <a key={index} href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="bg-white rounded-2xl shadow-md overflow-hidden border border-neutral-beige flex flex-col group cursor-pointer relative transition-all duration-300 hover:-translate-y-2 hover:shadow-xl" data-id="element-7">
              <div className="w-full aspect-[3/4] overflow-hidden relative bg-neutral-bg" data-id="element-8">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-105" data-id="element-9" />
                <div className="absolute top-3 right-3 bg-earth-accent text-white font-black text-[10px] px-2.5 py-0.5 rounded-full shadow-lg transform rotate-12 z-10" data-id="element-10">
                  GRATIS
                </div>
              </div>
              <div className="p-4 flex-grow flex flex-col justify-center bg-white relative z-20" data-id="element-11">
                <h4 className="text-sm sm:text-base font-black text-[#1A1A1A] mb-1 leading-tight" data-id="element-12">
                  🎁 {bonus.title}
                </h4>
                <p className="text-gray-600 text-xs sm:text-sm font-medium leading-relaxed" data-id="element-13">
                  {bonus.desc}
                </p>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}